import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";
import config from "../../config/api";

const API_URL = config.backendUrl

// -------------------------
// 1. CREATE OR UPDATE (BULK)
// -------------------------
export const createOrUpdateAssemblyInventory = createAsyncThunk(
    "assemblyInventory/createOrUpdate",
    async (inventoryArray, { rejectWithValue }) => {
        try {
            const res = await axiosInstance.post(
                `${API_URL}/assemblyinventory/add`,
                inventoryArray,
                { withCredentials: true }
            );
            return res.data; // returns updated/created array
        } catch (error) {
            return rejectWithValue(error.response?.data || "Error creating/updating");
        }
    }
);

// -------------------------
// 2. GET ALL INVENTORY
// -------------------------
export const getAllAssemblyInventory = createAsyncThunk(
    "assemblyInventory/getAll",
    async (_, { rejectWithValue }) => {
        try {
            const res = await axiosInstance.get(
                `${API_URL}/assemblyinventory/all`,
                { withCredentials: true }
            );
            return res.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || "Error fetching data");
        }
    }
);

// -------------------------
// 3. DELETE RECORD
// -------------------------
export const deleteAssemblyInventory = createAsyncThunk(
    "assemblyInventory/delete",
    async (id, { rejectWithValue }) => {
        try {
            const res = await axiosInstance.delete(
                `${API_URL}/assemblyinventory/delete/${id}`,
                { withCredentials: true }
            );
            return res.data; 
        } catch (error) {
            return rejectWithValue(error.response?.data || "Error deleting record");
        }
    }
);

// -------------------------------------------------------
// SLICE
// -------------------------------------------------------
const assemblyInventorySlice = createSlice({
    name: "assemblyInventory",
    initialState: {
        inventory: [],
        loading: false,
        error: null,
    },

    reducers: {},

    extraReducers: (builder) => {
        builder

            // ❗ CREATE / UPDATE
            .addCase(createOrUpdateAssemblyInventory.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createOrUpdateAssemblyInventory.fulfilled, (state, action) => {
                state.loading = false;

                // Replace entire inventory with updated results
                state.inventory = action.payload;
            })
            .addCase(createOrUpdateAssemblyInventory.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // ❗ GET ALL
            .addCase(getAllAssemblyInventory.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAllAssemblyInventory.fulfilled, (state, action) => {
                state.loading = false;
                state.inventory = action.payload;
            })
            .addCase(getAllAssemblyInventory.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // ❗ DELETE
            .addCase(deleteAssemblyInventory.fulfilled, (state, action) => {
                state.inventory = state.inventory.filter(
                    (item) => item._id !== action.payload
                );
            });
    },
});

export default assemblyInventorySlice.reducer;
